export default __webpack_public_path__ + "imgs/accesibility.68297b7bb8ebee64505429075ba45d46.svg";